<div>
  <h2 class="headline-06 mb-2 md:mt-3 text-[#0E365A]">Nombre</h2>
  <mat-radio-group [(ngModel)]="selectedPatient" class="flex flex-col gap-2">
      <div class="flex items-center bg-[#D2E4FF29] border border-[#B0C4DE] rounded-[20px] px-4 py-2 cursor-pointer min-h-[60px]">
        <mat-icon class="flex-shrink-0">person</mat-icon>
          <div class="ml-2 flex-1 min-w-0">
            <p class="font-semibold truncate">{{ nameOwner }}</p>
            <p class="text-sm text-gray-500">Titular</p>
          </div>
        <mat-radio-button class="ml-2 flex-shrink-0" value="titular"></mat-radio-button>
      </div>

<!-- DEPENDIENTES OCULTOS TEMPORALMENTE
      <div *ngIf="dependent.length > 0" class="flex items-center bg-[#D2E4FF29] border border-[#B0C4DE] rounded-[20px] px-4 py-2 cursor-pointer min-h-[60px]">
        <mat-icon class="flex-shrink-0">person</mat-icon>
        <div class="ml-2 flex-1 min-w-0">
          <p class="font-semibold truncate">{{ dependent[0].name }}</p>
          <p class="text-sm text-gray-500 truncate">{{ dependent[0].catalog.description }}</p>
        </div>
        <mat-radio-button class="ml-2 flex-shrink-0" [value]="dependent[0].name"></mat-radio-button>
      </div>

      <ng-container *ngIf="showAllDependents">
        <div *ngFor="let dep of dependent.slice(1)" class="flex items-center bg-[#D2E4FF29] border border-[#B0C4DE] rounded-[20px] px-4 py-2 cursor-pointer min-h-[60px]">
          <mat-icon class="flex-shrink-0">person</mat-icon>
          <div class="ml-2 flex-1 min-w-0">
            <p class="font-semibold truncate">{{ dep.name }}</p>
            <p class="text-sm text-gray-500 truncate">{{ dep.catalog.description }}</p>
          </div>
          <mat-radio-button class="ml-2 flex-shrink-0" [value]="dep.name"></mat-radio-button>
        </div>
      </ng-container>
FIN DEPENDIENTES OCULTOS TEMPORALMENTE -->
    </mat-radio-group>
</div>
<!-- DEPENDIENTES OCULTOS TEMPORALMENTE
<div>
  <button *ngIf="dependent.length > 1" class="w-full mt-2 border border-[#0E365A] rounded-full p-2 flex justify-between items-center" (click)="toggleDependents()">
    <p class="button-small text-[#0E365A]">{{ showAllDependents ? 'Ocultar dependientes' : 'Ver más dependientes' }}</p>
    <mat-icon>{{ showAllDependents ? 'remove' : 'add' }}</mat-icon>
  </button>
    <div
      class="w-full mt-2 border border-[#0E365A] rounded-full p-2 flex justify-between items-center"
       (click)="addNewDependent()">
      <p class="button-small text-[#0E365A]">Agregar nuevo dependiente</p>
      <mat-icon>add</mat-icon>
    </div>
</div>
FIN DEPENDIENTES OCULTOS TEMPORALMENTE -->
<div style="margin-top: 15px;">
    <h2 class="headline-06 mb-2 md:mt-3 text-[#0E365A]">
        <mat-icon>location_on</mat-icon> Dirección
    </h2>
    <!-- Estado de carga de ubicación -->
    <div *ngIf="isLoadingLocation" class="border border-gray-300 rounded-lg p-2 flex justify-between items-center mb-2 bg-gray-50">
        <div class="flex items-center gap-2">
            <mat-icon class="text-gray-500 animate-spin text-sm">refresh</mat-icon>
            <p class="paragraph-medium text-gray-500">Cargando ubicación...</p>
        </div>
    </div>

    <!-- Ubicación actual del mapa -->
    <div *ngIf="currentMapLocation && !isLoadingLocation"
         class="address-card-saved current-location-card"
         [class.selected]="!selectedAddress || (selectedAddress?.isCurrentLocation && !selectedAddress?.idAddress)"
         [class.banamex]="isBanamexAccount">
        <div class="address-flex-container" (click)="selectAddress(currentMapLocation)">
            <div class="address-info-section">
                <div class="address-icon-saved" [class.selected]="!selectedAddress || (selectedAddress?.isCurrentLocation && !selectedAddress?.idAddress)" [class.banamex]="isBanamexAccount">
                    <mat-icon [class.selected]="!selectedAddress || (selectedAddress?.isCurrentLocation && !selectedAddress?.idAddress)" [class.banamex]="isBanamexAccount">my_location</mat-icon>
                </div>
                <div class="address-text-container">
                    <p class="address-title-saved">
                        {{ currentMapLocation.colony }}
                    </p>
                    <p class="address-subtitle" *ngIf="!selectedAddress || selectedAddress?.isCurrentLocation">{{ currentMapLocation.identifier }}</p>
                </div>
            </div>
            <div class="address-actions-container">
                <button mat-icon-button (click)="toggleEditCurrentLocation($event)" class="address-edit-button">
                    <mat-icon>edit</mat-icon>
                </button>
                <div *ngIf="!selectedAddress || (selectedAddress?.isCurrentLocation && !selectedAddress?.idAddress)" class="address-check-icon" [class.banamex]="isBanamexAccount">
                    <mat-icon>check</mat-icon>
                </div>
            </div>
        </div>

        <!-- Buscador desplegable -->
        <div *ngIf="isEditingCurrentLocation" class="mt-3 pt-3 border-t border-blue-200 bg-blue-25">
            <p class="text-xs text-blue-600 mb-2">Busca una dirección y luego ajusta el pin en el mapa:</p>
            <!-- Input de búsqueda integrado -->
            <div class="mb-3">
                <div class="flex items-center bg-white rounded-lg border-2 border-blue-300 shadow-sm">
                    <mat-icon class="text-blue-600 ml-3 text-sm">search</mat-icon>
                    <input
                        class="flex-1 px-3 py-2 text-sm border-none outline-none rounded-lg"
                        type="text"
                        #searchInput
                        placeholder="Buscar dirección..."
                        (input)="onSearchInput($event)"
                    />
                    <button *ngIf="searchInput.value && !isSearching" mat-icon-button (click)="clearSearch(searchInput)" class=" p-1 mr-1" style="color: gray;">
                        <mat-icon class="text-sm">close</mat-icon>
                    </button>
                    <mat-icon *ngIf="isSearching" class="text-blue-600 mr-3 animate-spin text-sm">refresh</mat-icon>
                </div>
            </div>


        </div>
    </div>

    <div *ngIf="addresses.length > 0">
        <div class="address-card-saved" [class.selected]="selectedAddress === addresses[0]" [class.banamex]="isBanamexAccount" (click)="selectAddress(addresses[0])">
            <div class="address-flex-container">
                <div class="address-info-section">
                    <div class="address-icon-saved" [class.selected]="selectedAddress === addresses[0]" [class.banamex]="isBanamexAccount">
                        <mat-icon [class.selected]="selectedAddress === addresses[0]" [class.banamex]="isBanamexAccount">home</mat-icon>
                    </div>
                    <div class="address-text-container">
                        <p class="paragraph-medium"> {{ addresses[0].identifier}}</p>
                        <p class="paragraph-default text-[#97795B]">{{ addresses[0].streetNumber }}
                            Int {{ addresses[0].interiorDepartament || '' }},
                            {{ addresses[0].colony || '' }},
                            {{ addresses[0].cp || '' }},
                            {{ addresses[0].municipality || ''}},
                            {{addresses[0].state || ''}}
                        </p>
                    </div>
                </div>
                <div *ngIf="selectedAddress === addresses[0]" class="address-check-icon" [class.banamex]="isBanamexAccount">
                    <mat-icon>check</mat-icon>
                </div>
            </div>
        </div>
        <div *ngIf="showAllAddresses">
            <div *ngFor="let dir of addresses.slice(1)" class="address-card-saved" [class.selected]="selectedAddress === dir" [class.banamex]="isBanamexAccount" (click)="selectAddress(dir)">
                <div class="address-flex-container">
                    <div class="address-info-section">
                        <div class="address-icon-saved" [class.selected]="selectedAddress === dir" [class.banamex]="isBanamexAccount">
                            <mat-icon [class.selected]="selectedAddress === dir" [class.banamex]="isBanamexAccount">home</mat-icon>
                        </div>
                        <div class="address-text-container">
                            <p class="paragraph-medium">{{ dir.identifier }}</p>
                            <p class="paragraph-default text-[#97795B]">{{ dir.streetNumber || '' }}
                                Int  {{ dir.interiorDepartament || '' }},
                                {{ dir.colony || '' }}.{{ dir.cp || '' }},
                                {{ dir.municipality || '' }},
                                {{dir.state || ''}}
                            </p>
                        </div>
                    </div>
                    <div *ngIf="selectedAddress === dir" class="address-check-icon" [class.banamex]="isBanamexAccount">
                        <mat-icon>check</mat-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <button class="w-full border border-[#0E365A] rounded-full p-2 flex justify-between items-center"
        (click)="toggleAddresses()">
      <p class="button-small text-[#0E365A]">{{ showAllAddresses ? 'Ocultar direcciones' : 'Cambiar dirección' }}</p>
      <mat-icon>{{ showAllAddresses ? 'remove' : 'add' }}</mat-icon>
    </button>
    <button *ngIf="showAllAddresses" class="w-full mt-2 border border-[#0E365A] rounded-full p-2 flex justify-between items-center"
            (click)="goToAddAddress()">
      <p class="button-small text-[#0E365A]">Agregar dirección</p>
      <mat-icon>add</mat-icon>
    </button>
</div>
<div>
    <h2 class="headline-06 mb-2 md:mt-3 text-[#0E365A]">Referencias</h2>
    <p class="text-sm text-[#97795B] mb-2">Entre calles, o referencias que ayuden a localizarte.</p>
    <mat-form-field class="w-full" appearance="fill">
        <input matInput placeholder="Escribe aquí..." [(ngModel)]="reference" />
    </mat-form-field>
</div>
<button class="bg-[#2D1B0B] text-white w-full py-2 rounded-full cursor-pointer" (click)="goToConfirm()">
    Confirmar
</button>
